import { Maximize2, Plus, Sparkles, X } from "lucide-react";

// Dock/drawer header (scenario 674, plan 188 task 802): Sill spark icon +
// label + expand-to-full-page + new-conversation + close.
export function DockHeader({
  onExpand,
  onNewConversation,
  onClose,
}: {
  onExpand: () => void;
  onNewConversation: () => void;
  onClose: () => void;
}) {
  return (
    <div
      data-testid="copilot-dock-header"
      className="flex items-center gap-2 border-b border-border-soft px-3 py-2.5"
    >
      <span className="inline-flex size-6 items-center justify-center rounded-full bg-primary-soft text-primary">
        <Sparkles size={13} aria-hidden />
      </span>
      <p className="flex-1 text-sm font-semibold text-fg">Sill</p>
      <button
        type="button"
        aria-label="Expand to full page"
        onClick={onExpand}
        className="inline-flex size-8 items-center justify-center rounded-md text-fg-muted hover:bg-muted hover:text-fg"
      >
        <Maximize2 size={15} aria-hidden />
      </button>
      <button
        type="button"
        aria-label="New conversation"
        onClick={onNewConversation}
        className="inline-flex size-8 items-center justify-center rounded-md text-fg-muted hover:bg-muted hover:text-fg"
      >
        <Plus size={16} aria-hidden />
      </button>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="inline-flex size-8 items-center justify-center rounded-md text-fg-muted hover:bg-muted hover:text-fg"
      >
        <X size={16} aria-hidden />
      </button>
    </div>
  );
}
